import {ReferenceLineProps} from 'recharts';
import {useTheme} from '@material-ui/core/styles';
import {getVersionTicks} from '../utils';
import {TimeScale, Version} from '../../../../../types';

export interface UseReferenceLines {
    versions: Version[];
    timeScale: TimeScale;
}

const useReferenceLines = ({versions, timeScale}: UseReferenceLines): ReferenceLineProps[] => {
    const theme = useTheme();

    const versionTicks = getVersionTicks(versions, timeScale);

    return versionTicks.map(tick => ({
        x: tick,
        stroke: theme.palette.text.secondary,
        strokeDasharray: '3 3'
    }));
};

export default useReferenceLines;
